// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Rb-Q9","bigColWidth":"Table_bigColWidth__1DT-_","biggerColWidth":"Table_biggerColWidth__ejcIG","row":"Table_row__1VrTh","col":"Table_col__3dcG3"};